export const environment = {
  production: true,
  WebAPIHost: 'https://www.car-research.com/xrmcoreapi/api/1.0',
  rootURL: '/XrmCore/',
  showErrorInConsole: false,
  loginRoute: '/login',
  accessDeniedRoute: '/access_denied',
  defaultRouteAfterLogin: '/appraisal',
  GridRefreshFrequency: 300,
  SaveDashboardFrequency: 300,
  WidgetsScopeFrequency: 3600,
  WidgetsCategoryFrequency: 3600,
  DrillDownUrl: 'https://www.car-research.com/WebXRM/Reports/Report_Dashboard_Widget_Handler.aspx',
  DrillDownCTIUrl: 'https://www.car-research.com/WebXRM/Reports/Report_Dashboard_Widget_Handler_CallType.aspx',
  EmailUrl: 'https://www.car-research.com/WebXRM/Email/EmailClient_View.aspx',
  PrintCarUrl: 'https://www.carxrm.com/?OUTSIDEXRM=Y',
  googleApiKey: 'AIzaSyCGWTNPRNxH81-DWVk1BQYhKqAe1t6EPVE',
  aspReportsURL: 'https://www.car-research.com/carinteractive',
  aspReportsUrlFor184: 'https://www.car-research.com/carinteractive',
  webAppBaseUrl: 'https://www.car-research.com/XrmCore/',
  webAppMainDomain: 'https://www.car-research.com',
  pullCreditLink: 'https://www.700credit.com/affinitiv-xrm?action=lookup&screen=srv&program=vb'
};
